<i18n>
{
  "en": {
    "undefinedProduct": "Loading information..."
  },
  "es": {
    "undefinedProduct": "Cargando información..."
  }
}
</i18n>
<template>
  <v-card class="mb-2">
    <div class="d-flex flex-row mx-auto py-0 px-0">
      <v-card-text
        class="card-title | text-center font-weight-black text-truncate | pr-0 pb-2 pt-1">
        {{ title }}
      </v-card-text>
      <v-btn icon @click="onExpandClick" class="mr-1">
        <v-icon large color="#000000">{{ btnIcon }}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-show="!expanded">
        <div v-for="associatedProduct in associatedProducts"
             :key="associatedProduct.product.productIndexingGuid"
             class="pl-4 d-flex justify-space-between">
          <div class="sub-product d-flex align-center">
            <div class="text-truncate">{{ associatedProduct.title }}</div>
          </div>
          <div class="d-flex justify-end align-center">
            <v-chip color="#FFCCBC" class="ratio-chip justify-end mr-3" small>
              x{{ associatedProduct.product.ratio }}
            </v-chip>
            <v-btn icon @click="onEditClick(associatedProduct.product.productIndexingGuid)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="onDeleteClick(associatedProduct.product.productIndexingGuid)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

    </v-expand-transition>
  </v-card>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';
import { ProductIndexing } from '../models';

@Component
@MapGetters(['masterProductList'])
export default class ProductIndexingCard extends Vue {
  @Prop({ type: ProductIndexing, required: true }) productIndexing;

  expanded = false;

  get title() {
    return this.getTitle(this.productIndexing.referenceProductGuid);
  }

  get btnIcon() {
    return this.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down';
  }

  get associatedProducts() {
    return this.productIndexing.associatedProducts.map((associate) => ({
      title: this.getTitle(associate.associatedProductGuid),
      product: associate
    }));
  }

  getTitle(guid) {
    const found = this.masterProductList.find((product) => product.guid === guid);
    return found?.commercialName || found?.name || this.$t('undefinedProduct');
  }

  onExpandClick() {
    this.expanded = !this.expanded;
  }

  onEditClick(productIndexingGuid) {
    this.$emit('edit', { productIndexing: this.productIndexing, productIndexingGuid });
  }

  onDeleteClick(productIndexingGuid) {
    this.$emit('delete', { referenceProductGuid: this.productIndexing.referenceProductGuid, productIndexingGuid });
  }
}
</script>
<style scoped>
.card-title {
  font-size: 1em;
  max-width: 100%;
}

.sub-product {
  max-width: 50%;
}

.ratio-chip {
  min-width: 4.5em;
}
</style>
